export default "__VITE_ASSET__DByxZwGL__"